import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { BaseUnitComponent } from "./BaseUnitComponent";

class WeightUnitComponent extends BaseUnitComponent {
    protected get unitLabels(): { [unit: number]: string } {
        return {
            [WeightUnit.Gram]: "GramUnitSymbolLabel",
            [WeightUnit.Kilogram]: "KilogramUnitSymbolLabel",
            [WeightUnit.Pound]: "PoundUnitSymbolLabel"
        };
    }

    protected get readonlyUnitLabels(): { [unit: number]: string } {
        return {
            [WeightUnit.Gram]: this.props.useAbbreviation ? "GramUnitSymbolLabel" : "GramUnitLabel",
            [WeightUnit.Kilogram]: this.props.useAbbreviation ? "KilogramUnitSymbolLabel" : "KilogramUnitLabel",
            [WeightUnit.Pound]: this.props.useAbbreviation ? "PoundUnitSymbolLabel" : "PoundUnitLabel"
        };
    }
}

export { WeightUnitComponent };
